import { getFromWindowRef } from '@avantia/client-and-server-utilities';
import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { HpSubmitFormResult } from '../actions/submitClaimAction';
import { HpClaimsDebugFlags, logWarning } from '../clientLogging';
import { getConfig } from '../config/configuration';
import {
  HpPostAnswersMiddlewarePostData,
  HpPostAnswersMiddlewareState,
  createPostAnswersMiddleware
} from '../engineClient/store/createPostAnswersMiddleware';
import { setMetaDataInAnswers } from '../engineClient/tools/clientAndServerUtilities';
import { getInitialState } from '../reducers/initialState';
import { rootReducer } from '../reducers/rootReducer';
import { questionIds } from '../types/questionConstants';

declare const window: any;

const { developerModeEnabled, websiteEndpoint } = getConfig();

export interface HpClaimsPostedAnswersMiddlewareState extends HpPostAnswersMiddlewareState {
  changesToSection: number;
}

export interface HpClaimsPostedAnswersPostData extends HpPostAnswersMiddlewarePostData {
  incrementedSectionId?: string | undefined;
  totalSectionChanges?: number | undefined;
}

interface WinProps {
  submitFormResult: HpSubmitFormResult;
}

const postAnswersMiddleware = createPostAnswersMiddleware<
  HpClaimsPostedAnswersMiddlewareState,
  HpClaimsPostedAnswersPostData
>({
  websiteEndpoint,
  createBlankState: () => {
    return { changesToSection: 0 };
  },
  setExtraPostData: ({ answers }, mwstate) => {
    mwstate.changesToSection++;

    const answersWithoutPolicyData = { ...answers };
    delete answersWithoutPolicyData[questionIds.policyData];
    const { submitFormResult } = getFromWindowRef<WinProps>(['submitFormResult']) || {};
    if ((submitFormResult && submitFormResult.success) || submitFormResult === null) {
      const newAnswers = { ...answersWithoutPolicyData };
      setMetaDataInAnswers({
        productId: getConfig().productIdDefault,
        answers: newAnswers,
        metadata: { isJourneyComplete: true }
      });
      return { answers: newAnswers };
    }

    return { answers: answersWithoutPolicyData };
  }
});

const middleware = [thunkMiddleware, postAnswersMiddleware];

let composeEnhancers = compose;

if (developerModeEnabled) {
  // middleware.push(createLogger());

  // add support for Redux dev tools
  const devTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  composeEnhancers = devTools || composeEnhancers;
  if (devTools) {
    logWarning("Adding 'redux dev tools' middleware.", HpClaimsDebugFlags.None);
  }

  logWarning("Adding 'redux-immutable-state-invariant' middleware.", HpClaimsDebugFlags.None);
  middleware.unshift(
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require('redux-immutable-state-invariant').default({
      // TODO Solve the displayState state invariant issue
      ignore: ['questionSet.displayState'] // this probably has a circular dependency, in any case, if not ignored it makes the site hang.
    })
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function configureStore() {
  return createStore(rootReducer, getInitialState() as any, composeEnhancers(applyMiddleware(...middleware)));
}
